import { render, staticRenderFns } from "./PersonAssetsTable.vue?vue&type=template&id=78886391&scoped=true&"
import script from "./PersonAssetsTable.vue?vue&type=script&lang=js&"
export * from "./PersonAssetsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78886391",
  null
  
)

export default component.exports